
import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../_services/navigation.service'; 

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private navigationService: NavigationService) { } 

  ngOnInit() {
    this.navigationService.resetNavigation();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/page-not-found/page-not-found.component.ts